export default "__VITE_ASSET__accad5ff__"